import * as React from "react";
import Box from "../box";
import type { TextProps } from "./text.types";
import { getTextTransformStyles, getVariantStyles } from "./text.helper";

function Text(props: TextProps) {
  return (
    <Box
      margin="$0"
      {...props.attributes}
      {...props.domAttributes}
      as={props.as}
      {...getVariantStyles(props.variant ?? "body", props.fontFamily)}
      {...getTextTransformStyles({
        ellipsis: props.ellipsis,
        underline: props.underline,
      })}
      color={props.color}
      fontSize={props.fontSize}
      fontWeight={props.fontWeight}
      letterSpacing={props.letterSpacing}
      lineHeight={props.lineHeight}
      textAlign={props.textAlign}
      textTransform={props.textTransform}
      wordBreak={props.wordBreak}
      className={props.className}
    >
      {props.children}
    </Box>
  );
}

Text.defaultProps = {
  as: "p",
  fontSize: "$sm",
  color: "$text",
  variant: "body",
  wordBreak: "break-word",
  ellipsis: false,
  underline: false,
};

export default Text;
